import { LoadableAfterPaint } from '@confluence/loadable';

export const OmniBarLoader = LoadableAfterPaint<Record<string, never>>({
	loader: async () => {
		const module = await import(
			/* webpackChunkName: "loadable-OmniBar" */ './components/OmniBarWrapper.tsx'
		);
		return module.OmniBarWrapper;
	},
});
